import _ from 'lodash';
import qs from 'query-string';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import { times } from '../api';
import i18n, { DEFAULT_LANGUAGE, getLanguage } from 'src/i18n';
const GATEWAY_API_ENABLED = config.servers.gateway.enabled;
const GATEWAY_API_URL = config.servers.gateway.url;
const AUTH_API_ENABLED = config.servers.auth.enabled;
const AUTH_API_URL = config.servers.auth.url;
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
export interface LoginServerDto {
  access_token: string;
  token_type: string;
  expires_in: number;
  scope: string;
  need_password_change: boolean;
  password_change_alert: boolean;
  managed_dept_codes: string[];
  jti: string;
}
export interface LoginDto {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
  scope: string;
  needPasswordChange: boolean;
  passwordChangeAlert: boolean;
  managedDeptCodes: string[];
  jti: string;
}
export interface TokenDto {
  alg: string;
  value: string;
}
interface SessionInitReqDto {
  userId: string;
  deviceId: string;
  timestamp: number;
  url: string;
}
export interface SessionInitResDto {
  timestamp: number;
  url: string;
}
interface AuthApi {
  logIn(username: string, password: string, redirectUrl: string): Promise<LoginDto>;
  logInWithTempToken(redirectUrl: string, token: string): Promise<LoginDto>;
  logOut(username?: string): Promise<void>;
  getTokenKey(): Promise<TokenDto>;
  // hasTokenKey(): Promise<TokenValidDto>;
  sessionInit(reqDto: SessionInitReqDto): Promise<SessionInitResDto>;
  fxmSessionDestroy(): Promise<void>;
}
class AuthServerApi implements AuthApi {
  async logIn(username: string, password: string, redirectUrl: string): Promise<LoginDto> {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    params.append('redirectUrl', redirectUrl);
    params.append('lang', getLanguage());

    const resp = await axios.post<LoginServerDto>(`${GATEWAY_API_URL}/session/login`, params);

    const loginDto = this.toLoginDto(resp.data);

    return Promise.resolve(loginDto);
  }
  async logInWithTempToken(redirectUrl: string, token: string): Promise<LoginDto> {
    const params = new URLSearchParams();
    params.append('redirectUrl', redirectUrl);
    params.append('lang', getLanguage());
    params.append('bearer', token);

    const resp = await axios.post<LoginServerDto>(`${GATEWAY_API_URL}/session/login/token`, params);

    const loginDto = this.toLoginDto(resp.data);

    return Promise.resolve(loginDto);
  }
  async logOut(username?: string): Promise<void> {
    const params = new URLSearchParams();
    if (username) {
      params.append('username', username);
    }
    await axios.post<void>(`${GATEWAY_API_URL}/session/logout`, params, {
      timeout: 3000,
    });
  }
  async getTokenKey(): Promise<TokenDto> {
    const resp = await axios.get<TokenDto>(`${AUTH_API_URL}/oauth/token_key`);
    return resp.data;
  }
  // hasTokenKey(): Promise<TokenValidDto>;
  async sessionInit(reqDto: SessionInitReqDto): Promise<SessionInitResDto> {
    const resp = await axios.post<SessionInitResDto>(`${AUTH_API_URL}/idp/session-init`, reqDto);
    return resp.data;
  }
  async fxmSessionDestroy(): Promise<void> {
    if (!FXM_API_ENABLED) return;
    await axios.delete<void>(`${FXM_API_URL}/sessions/destroy`);
  }

  private toLoginDto(serverDto: LoginServerDto): LoginDto {
    const loginDto: LoginDto = {
      accessToken: serverDto.access_token,
      tokenType: serverDto.token_type,
      expiresIn: serverDto.expires_in,
      scope: serverDto.scope,
      needPasswordChange: serverDto.need_password_change,
      passwordChangeAlert: serverDto.password_change_alert,
      managedDeptCodes: serverDto.managed_dept_codes,
      jti: serverDto.jti,
    };

    return loginDto;
  }
}
const authApi = new AuthServerApi();
export default authApi;
